export const displayDateFormats = {
  mmmDDyyyy: 'MMM DD, YYYY',
  mmmDDyyyyhhmma: 'MMM DD, YYYY hh:mm A',
};
